<template>
  <Breadcrumbs
      title="Distributor Target"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Distributor Target', path: '/distributor-target' },
    ]"
  />
  
  <div class="container-fluid">
    <div class="row project-cards">
      <distributorTarget/>
    </div>
  </div>
</template>
  
<script>
import distributorTarget from './distributor_target_form.vue'
export default {
  name: 'indexList',
  components: {
    distributorTarget,
  },
}
</script>